module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "exposures-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "exposures",
    attrs: {
      "id": "exposures"
    }
  }, [_c('transition', {
    attrs: {
      "name": "exposures-fade",
      "enter-active-class": "animated fadeIn"
    }
  }, [(!_vm.selectedSlug) ? _c('div', {
    key: "grid",
    staticClass: "grid-component",
    class: {
      'deactivate': _vm.selectedSlug
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.banner.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.banner.copy)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "exposures-grid"
  }, _vm._l((_vm.exposures), function(exposure, index) {
    return _c('div', {
      staticClass: "grid-item",
      on: {
        "click": function($event) {
          _vm.getExposure(exposure.exposure_slug)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": exposure.mobile.gridImageX1,
        "srcset": (exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(exposure.exposure_label)
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "nav-to-top"
  }, [_c('a', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Back to Top "), _c('span', {
    staticClass: "glyph"
  }, [_vm._v("↑")])])])])])]) : _c('mobile-content-exposure', {
    key: "detail",
    attrs: {
      "slug": _vm.selectedSlug,
      "service": _vm.selectedService,
      "premise": _vm.selectedPremise
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e20fdbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileContentExposures.vue
// module id = 445
// module chunks = 1